import { render } from "./FormAgend.vue?vue&type=template&id=2a4d2f3a&scoped=true"
import script from "./FormAgend.vue?vue&type=script&lang=js"
export * from "./FormAgend.vue?vue&type=script&lang=js"

import "./FormAgend.vue?vue&type=style&index=0&id=2a4d2f3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a4d2f3a"]])

export default __exports__